import classes from './Room.module.css';
import {Fragment, useEffect, useState} from "react";
import defScreen from "../../../store/thumbnail_image004.png"
import axios from "axios";
import { path, assetsBaseUrl } from "../../../routes";

// Parse meeting date strictly as LOCAL time (no timezone conversion)
const parseLocalDateTime = (value) => {
    if (!value) return NaN;
    const s = String(value).trim();
    if (!s) return NaN;
    let clean = s
        .replace('T', ' ')
        .replace(/\.\d+$/, '')
        .replace(/[+-]\d{2}:?\d{2}$/, '')
        .replace(/Z$/, '');
    const [datePart, timePart] = clean.split(' ');
    if (!datePart || !timePart) return NaN;
    const [yStr, mStr, dStr] = datePart.split('-');
    const [hStr, minStr, secStr] = timePart.split(':');
    const y = Number(yStr);
    const m = Number(mStr);
    const d = Number(dStr);
    const h = Number(hStr);
    const min = Number(minStr);
    const sec = Number(secStr || 0);
    if (![y, m, d, h, min, sec].every((n) => Number.isFinite(n))) return NaN;
    return new Date(y, m - 1, d, h, min, sec).getTime();
};

const Room = (props) => {
    const [, setactTime] = useState("undefined");
    const [, setactDate] = useState("undefined");
    const [logoOrg, setLogoOrg] = useState(props.logoOrg);
    const [roomtext, setroomText] = useState(props.text);
    const [roomID] = useState(props.roomId);
    const [isRunning, setIsRunning] = useState(false);
    const [meetingData, setMeetingData] = useState(null);
    const [refreshTrigger, setRefreshTrigger] = useState(0);
    
    // Debug: log roomID when component mounts or roomID changes
    useEffect(() => {
        console.log(`[Room] Component initialized with roomID=${roomID} (props.roomId=${props.roomId})`);
    }, [roomID, props.roomId]);
    // const actTime = `${String(dt.getHours()).padStart(2, "0")}:${String(dt.getMinutes()).padStart(2, "0")}`;
    //const actDate = `${String(dt.getDate()).padStart(2, "0")}. ${String(dt.getMonth() + 1).padStart(2, "0")}. ${dt.getFullYear()}`;
    const getTime = () => {
        const now = new Date();

        // Získání jednotlivých částí data
        const year = now.getFullYear();
        const month = String(now.getMonth() + 1).padStart(2, '0'); // Měsíce jsou indexovány od 0
        const day = String(now.getDate()).padStart(2, '0');

        // Získání jednotlivých částí času
        const hours = String(now.getHours()).padStart(2, '0');
        const minutes = String(now.getMinutes()).padStart(2, '0');
        const seconds = String(now.getSeconds()).padStart(2, '0');

        // Sestavení výsledného řetězce
        return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}`;
    }

    useEffect(() => {
        // Debug: log current URL and roomID
        if (typeof window !== 'undefined') {
            const urlParams = new URLSearchParams(window.location.search);
            const roomFromUrl = urlParams.get('room');
            console.log(`[Room] useEffect: roomID=${roomID}, props.roomId=${props.roomId}, room from URL=${roomFromUrl}, full URL=${window.location.href}`);
        }
        
        // Funkce, která se spustí každou minutu

        const resetVal = async () =>{
            await axios.post(`${path}/updateReset/${roomID}`)
        }
        const getReset = async () => {
            try {
                const response = await axios.get(`${path}/getReset/${roomID}`);
                const need = response.data?.[0]?.needUpdate;
                if (need === 1 || need === true) {
                    console.log("[Room] Změna nastavení – obnovuji data bez reloadu");
                    await resetVal();
                    setRefreshTrigger((t) => t + 1);
                }
            } catch (error) {
                // ignore
            }
        };


        const send = async () =>{
            try {
                const currentTime = getTime();
                // Use query parameter endpoint directly for production (dev.csgcontrols.cz) due to IIS routing issues
                const useQueryEndpoint = path.includes('dev.csgcontrols.cz') || path.includes('csgcontrols.cz');
                const url = useQueryEndpoint 
                    ? `${path}/getMeetingQuery?id=${roomID}&day=${encodeURIComponent(currentTime)}`
                    : `${path}/getMeeting/${roomID}/${encodeURIComponent(currentTime)}`;
                console.log(`[Room] Fetching meeting: roomID=${roomID}, currentTime=${currentTime}, url=${url}, useQueryEndpoint=${useQueryEndpoint}`);
                const response = await axios.get(url);
                const data = Array.isArray(response.data) ? response.data : [];
                if (data.length > 0) {
                    const rec = data[0];
                    setroomText(rec.description ?? '');
                    setLogoOrg(rec.path ? (assetsBaseUrl + rec.path) : null);
                    setMeetingData(rec);
                    
                    // Check if meeting is currently running (local time comparison)
                    const now = Date.now();
                    const dateFrom = parseLocalDateTime(rec.dateFrom);
                    const dateTo = parseLocalDateTime(rec.dateTo);
                    const running = !isNaN(dateFrom) && !isNaN(dateTo) && dateFrom <= now && now <= dateTo;
                    setIsRunning(running);
                } else {
                    setLogoOrg(null);
                    setroomText(null);
                    setMeetingData(null);
                    setIsRunning(false);
                }
            }
            catch (error){
                setLogoOrg(null);
                setroomText(null);
                setMeetingData(null);
                setIsRunning(false);
            }
        }


        const updateMinute = () => {
            const dt = new Date()
            setactTime(`${String(dt.getHours()).padStart(2, "0")}:${String(dt.getMinutes()).padStart(2, "0")}`)
            setactDate(`${String(dt.getDate()).padStart(2, "0")}. ${String(dt.getMonth() + 1).padStart(2, "0")}. ${dt.getFullYear()}`)
            
                // Update running status every second (local time comparison)
                if (meetingData) {
                    const now = Date.now();
                    const dateFrom = parseLocalDateTime(meetingData.dateFrom);
                    const dateTo = parseLocalDateTime(meetingData.dateTo);
                    setIsRunning(!isNaN(dateFrom) && !isNaN(dateTo) && dateFrom <= now && now <= dateTo);
                }
        };
        updateMinute();
        send();
        const intervalId = setInterval(updateMinute, 1000);
        const intervalId2 = setInterval(send, 60 * 1000);
        getReset();
        const intervalId3 = setInterval(getReset, 3 * 1000);
        const onVisibility = () => {
            if (typeof document !== 'undefined' && document.visibilityState === 'visible') getReset();
        };
        document.addEventListener('visibilitychange', onVisibility);
        return () => {
            clearInterval(intervalId);
            clearInterval(intervalId2);
            clearInterval(intervalId3);
            document.removeEventListener('visibilitychange', onVisibility);
        };
    }, [roomID, refreshTrigger]);

    let noMeeting = (<div className={classes.mainNo}>
        <img src={defScreen} alt={"No meeting"}/>
    </div>)
    let meeting = (<div className={classes.main}>
        <div className={classes.header}>
            <img src={`${path}/admin/org_logo//RadissonBlu-logo.png`} alt={"Logo radisson"}/>
        </div>
        <div className={classes.body}>
            <p>{roomtext}</p>
            {logoOrg && <img src={logoOrg} alt={"logo"}/>}
        </div>

    </div>)


    return <>
        {(roomtext != null && roomtext !== '') ? meeting : noMeeting}</>
}
export default Room